import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isLandingPage = location.pathname === '/';

  return (
    <Navbar 
      expand="lg" 
      className={isLandingPage ? 'navbar-landing' : 'navbar-app'} 
      fixed="top"
      variant={isLandingPage ? 'dark' : 'light'}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold">
          <i className="fas fa-network-wired me-2"></i>
          NetworqPay
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          {!user ? (
            <>
              {/* Public Navigation */}
              <Nav className="me-auto">
                {isLandingPage && (
                  <>
                    <Nav.Link href="#features">Features</Nav.Link>
                    <Nav.Link href="#how-it-works">How It Works</Nav.Link>
                    <Nav.Link href="#about">About</Nav.Link>
                  </>
                )}
              </Nav>
              
              <Nav className="ms-auto align-items-center">
                <Button
                  variant="outline-light"
                  className="me-2"
                  onClick={() => navigate('/login')}
                >
                  Sign In
                </Button>
                <Button
                  variant="primary"
                  onClick={() => navigate('/register')}
                >
                  Get Started
                </Button>
              </Nav>
            </>
          ) : (
            <>
              {/* Authenticated Navigation */}
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/app/dashboard">
                  <i className="fas fa-tachometer-alt me-1"></i>
                  Dashboard
                </Nav.Link>
                <Nav.Link as={Link} to="/app/tasks">
                  <i className="fas fa-tasks me-1"></i>
                  Tasks
                </Nav.Link>
                <Nav.Link as={Link} to="/app/rewards">
                  <i className="fas fa-coins me-1"></i>
                  Rewards
                </Nav.Link>
                <Nav.Link as={Link} to="/app/profile">
                  <i className="fas fa-user me-1"></i>
                  Profile
                </Nav.Link>
                {user.role === 'admin' && (
                  <Nav.Link as={Link} to="/app/admin">
                    <i className="fas fa-cog me-1"></i>
                    Admin
                  </Nav.Link>
                )}
              </Nav>
              
              <Nav className="ms-auto align-items-center">
                <Nav.Item className="me-3">
                  <span className="navbar-text">
                    Welcome, <strong>{user.name || user.email}</strong>
                  </span>
                </Nav.Item>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={handleLogout}
                >
                  <i className="fas fa-sign-out-alt me-1"></i>
                  Logout
                </Button>
              </Nav>
            </>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;